var MonetateActionType = /* @__PURE__ */ ((MonetateActionType2) => {
  MonetateActionType2["OmnichannelJson"] = "monetate:action:OmnichannelJson";
  return MonetateActionType2;
})(MonetateActionType || {});
var MonetateEventType = /* @__PURE__ */ ((MonetateEventType2) => {
  MonetateEventType2["DecisionRequest"] = "monetate:decision:DecisionRequest";
  return MonetateEventType2;
})(MonetateEventType || {});
export {
  MonetateActionType,
  MonetateEventType
};
//# sourceMappingURL=types.js.map
